export default function within(ids, coords, qx, qy, r, nodeSize) {
  var stack = [0, ids.length - 1, 0];
  var result = [];
  var r2 = r * r;

  while (stack.length) {
    var axis = stack.pop();
    var right = stack.pop();
    var left = stack.pop();

    if (right - left <= nodeSize) {
      for (var i = left; i <= right; i++) {
        if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
      }

      continue;
    }

    var m = Math.floor((left + right) / 2);
    var x = coords[2 * m];
    var y = coords[2 * m + 1];
    if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);
    var nextAxis = (axis + 1) % 2;

    if (axis === 0 ? qx - r <= x : qy - r <= y) {
      stack.push(left);
      stack.push(m - 1);
      stack.push(nextAxis);
    }

    if (axis === 0 ? qx + r >= x : qy + r >= y) {
      stack.push(m + 1);
      stack.push(right);
      stack.push(nextAxis);
    }
  }

  return result;
}

function sqDist(ax, ay, bx, by) {
  var dx = ax - bx;
  var dy = ay - by;
  return dx * dx + dy * dy;
}